import { render, staticRenderFns } from "./SorveglianzaRefertiList.vue?vue&type=template&id=08331d64&scoped=true"
import script from "./SorveglianzaRefertiList.vue?vue&type=script&lang=js"
export * from "./SorveglianzaRefertiList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08331d64",
  null
  
)

export default component.exports